import React, { useState, useEffect, useRef } from 'react';
import '../../styles/carousel-inf.css'; // Import the CSS file below
import { InviewAnim } from './animations';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';


export default function InfiniteCarousel({ toProducts, toBrands, toNew }) {

    const CAROUSEL_DATA = [
        {
            id: '1',
            title: 'NEW ARRIVALS',
            statement: 'Shop for the latest gadgets',
            image: '/sky-phone.png',
            navigation: toNew
        },
        {
            id: '2',
            title: 'WIDE RANGE OF PRODUCTS',
            image: '/variety.png',
            statement: 'Phones, accesories, power banks, speakers',
            navigation: toProducts
        },
        {
            id: '3',
            title: 'SMART BRANDS',
            image: '/categories.png',
            statement: 'We deal in leading brands',
            navigation: toBrands
        },
    ];

    // Duplicate items for seamless infinite looping
    const INFINITE_DATA = [
        CAROUSEL_DATA[CAROUSEL_DATA.length - 1], // Last item at the start buffer
        ...CAROUSEL_DATA,
        CAROUSEL_DATA[0],                        // First item at the end buffer
    ];


    const [currentIndex, setCurrentIndex] = useState(1); // Start at real first item
    const [isTransitioning, setIsTransitioning] = useState(true);
    const [isPlayed, setIsPlayed] = useState(false);
    const autoPlayTimer = useRef(null);

    // Handle automatic 3-second sliding logic
    useEffect(() => {
        const startAutoPlay = () => {
            stopAutoPlay();
            autoPlayTimer.current = setInterval(() => {
                handleNext();
            }, 5000);
        };

        const stopAutoPlay = () => {
            if (autoPlayTimer.current) {
                clearInterval(autoPlayTimer.current);
            }
        };

        const handleNext = () => {
            setIsTransitioning(true);
            setCurrentIndex((prevIndex) => prevIndex + 1);
        };
        startAutoPlay();
        return () => stopAutoPlay(); // Clean up timer on unmount/index change
    }, [currentIndex]);


    const startAutoPlay = () => {
        stopAutoPlay();
        autoPlayTimer.current = setInterval(() => {
            handleNext();
        }, 5000);
    };

    const stopAutoPlay = () => {
        if (autoPlayTimer.current) {
            clearInterval(autoPlayTimer.current);
        }
    };

    const handleNext = () => {
        setIsTransitioning(true);
        setCurrentIndex((prevIndex) => prevIndex + 1);
    };

     const handleToNext = () => {
        setIsPlayed(true);
        setCurrentIndex((prevIndex) => prevIndex + 1);
        handleTransitionEnd();
    };

    const handleToPrev = () => {
        setIsPlayed(true);
        setCurrentIndex((prevIndex) => prevIndex - 1);
        handleTransitionEnd();
    }


    // Detect when the CSS transition finishes to handle the infinite "snap"
    const handleTransitionEnd = () => {
        // If we've reached the end buffer (duplicated Slide 1)
        if (currentIndex === INFINITE_DATA.length - 1) {
            setIsTransitioning(false); // Turn off CSS animation
            setCurrentIndex(1);        // Instantly snap to real Slide 1
        }
        // If we've reached the start buffer (duplicated Slide 3)
        else if (currentIndex === 0) {
            setIsTransitioning(false); // Turn off CSS animation
            setCurrentIndex(INFINITE_DATA.length - 2); // Instantly snap to real Slide 3
        }
    };

    return (
        <div className="carousel-container">
            <div
                className="carousel-track"
                onMouseEnter={stopAutoPlay} // Pause autoplay when mouse hovers
                onMouseLeave={startAutoPlay} // Resume autoplay when mouse leaves
                onTransitionEnd={handleTransitionEnd}
                style={{
                    transform: `translateX(-${currentIndex * 100}%)`,
                    transition: (isTransitioning || isPlayed) ? 'transform 0.5s ease-in-out' : 'none',
                }}
            >
                {INFINITE_DATA.map((item, index) => (
                    <div
                        key={`${item.id}-${index}`}
                        className="carousel-slide"
                        style={{
                            backgroundImage: `url(${item.image})`,
                            backgroundSize: 'cover',
                            height: 400
                        }}
                    >
                        <InviewAnim inView={'slide-in-x-after'} notInView={'slide-in-x-before'}>
                            <div className="glassy slide-label">{item.title}</div>
                        </InviewAnim>

                        <InviewAnim inView={'slide-right-after'} notInView={'slide-right-before'}>
                            <div className="blk-glass stm">
                                {item.statement}
                            </div>
                        </InviewAnim>
                        <InviewAnim inView={'slide-in-y-after'} notInView={'slide-in-y-before'}>
                            <button className="see-more" onClick={item.navigation}>Learn more</button>
                        </InviewAnim>
                    </div>
                ))}
            </div>

            {/* Pagination Dots */}
            <div className="pagination">
                {CAROUSEL_DATA.map((_, index) => {
                    const isActive = currentIndex - 1 === index ||
                        (currentIndex === INFINITE_DATA.length - 1 && index === 0) ||
                        (currentIndex === 0 && index === CAROUSEL_DATA.length - 1);

                    return (
                        <div
                            key={index}
                            className={`dot ${isActive ? 'active-dot' : ''}`}
                        />
                    );
                })}
            </div>
            <div className="direction-buttons">
                <button 
                    className="direction-button" 
                    onClick={handleToPrev}
                >
                    <FontAwesomeIcon icon={faChevronLeft} />
                </button>
                <button className="direction-button">
                    <FontAwesomeIcon icon={faChevronRight} onClick={handleToNext}/>
                </button>
            </div>
        </div>
    );
}